export const LOGIN_REQUEST = 'auth/LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'auth/LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'auth/LOGIN_FAILURE';

export const REGISTER_REQUEST = 'auth/REGISTER_REQUEST';
export const REGISTER_SUCCESS = 'auth/REGISTER_SUCCESS';
export const REGISTER_FAILURE = 'auth/REGISTER_FAILURE';

export const FETCH_AUTH_ME_REQUEST = 'auth/FETCH_AUTH_ME_REQUEST';
export const FETCH_AUTH_ME_SUCCESS = 'auth/FETCH_AUTH_ME_SUCCESS';
export const FETCH_AUTH_ME_FAILURE = 'auth/FETCH_AUTH_ME_FAILURE';

export const LOGOUT = 'auth/LOGOUT';
export const CLEAR_AUTH_ERROR = 'auth/CLEAR_AUTH_ERROR';
